import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ClusterWithSite } from '../../sections/types/ClusterWithSite';

export interface IFetchAllClustersParams {
    siteId: string;
}

export interface IFetchAllClustersResult extends IResult {
  success?: ReadonlyArray<ClusterWithSite>;
  siteId: string;
}

export class FetchAllClusterstRequest extends Request<IFetchAllClustersParams, IFetchAllClustersResult> {
  constructor(params: IFetchAllClustersParams) {
    super('fetchAllClusters', params);
  }
}
